import React, { useState } from 'react';
import { useLocation, Router } from 'react-router-dom';
import DefinitionHandleSelect from 'Utils/DefinitionHandleSelect';
import DefinitionHandleSelectAll from 'Utils/DefinitionHandleSelectAll';
import SideBarContainer from 'Containers/SideBarContainer';
import useCourse from './Hooks/useCourse';
import Search from '../../Components/Search';
import Title from '../../Components/Title';
import DropDown from '../../Components/DropDown';
import { containerEmployee, searchContainer, findContainer, ContainerAcordion, Space } from './style';
import useDropDown from './Hooks/useDropdown';
import useComponent from './Hooks/useComponent';
import Acordion from '../../Components/Acordion';
import SelectTable from '../../Components/SelectTable';
import useTranslation from '../../Hooks/useTranslation';

export default function DefinitionJobTitle() {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  if (location?.state?.isComingFrom !== '/definicion/seleccion/puesto') {
    return <Router to="/definicion" />;
  }
  const jobTitleId = location?.state?.jobTitle;
  const departmentId = location?.state?.department;
  const { courses, coursesByDepartment, coursesByEnterprise, terminals, categories, saveCourses, defaultSelectedIds } =
    useCourse({ departmentId, jobTitleId }, setIsLoading);

  const { setSearch, setTerminal, setCategory, coursesFilters } = useDropDown({
    courses,
  });
  const { thereIsComponent } = useComponent({ categories });
  const { t2 } = useTranslation('DefinitionJobTitle');
  const titles = [t2('Terminal'), t2('Category')];
  const options = [terminals, categories];
  const methods = [setTerminal, setCategory];
  const [selectedRows, setSelectedRows] = useState([]);
  const [unselectedRows, setUnselectedRows] = useState([]);
  const [selectAllItems, setSelectAllItems] = useState(false);

  const disableButton = () => {
    if (defaultSelectedIds.length <= 0) {
      return !selectedRows.length > 0;
    }

    return !(selectedRows.length > 0 || unselectedRows.length > 0);
  };

  const handleSelect = (row, indx) => {
    const argPayload = {
      defaultSelectedIds,
      unselectedRows,
      selectedRows,
      setSelectedRows,
      setUnselectedRows,
      courseList: coursesFilters,
    };
    DefinitionHandleSelect(row, indx, 5, argPayload);
  };

  const handleSelectAll = () => {
    const argPayload = {
      courseList: coursesFilters,
      defaultSelectedIds,
      setUnselectedRows,
      setSelectedRows,
      setSelectAllItems,
      selectAllItems,
      unselectedRows,
    };
    DefinitionHandleSelectAll(5, argPayload);
  };

  return (
    <SideBarContainer>
      <div style={containerEmployee}>
        <Title
          title={t2('Title')}
          subtitle={t2('SubTitle')}
          textButton={t2('ButtonSave')}
          eventButton={() => saveCourses(selectedRows.concat(unselectedRows))}
          disabledButton={disableButton()}
        />
        <ContainerAcordion>
          <Acordion
            title={t2('AcordionCompany')}
            information={coursesByEnterprise}
            thereIsComponent={thereIsComponent}
            limit={4}
          />
          <Space />
          <Acordion
            title={t2('AcordionDepartment')}
            information={coursesByDepartment}
            thereIsComponent={thereIsComponent}
            limit={4}
          />
        </ContainerAcordion>
        <div style={searchContainer}>
          <div style={{ width: '40%' }}>
            <Search setData={setSearch} placeholder={t2('Search')} />
          </div>
          <div style={findContainer}>
            {titles.map((title, index) => {
              const id = title + index;
              return <DropDown key={id} title={title} options={options[index]} setData={methods[index]} />;
            })}
          </div>
        </div>
        <SelectTable
          information={coursesFilters}
          headers={[t2('Name'), t2('Terminal'), t2('TimeCourse'), t2('Category')]}
          limit={4}
          thereIsComponent={thereIsComponent}
          floatingMessage={t2('SelectedCourses')}
          selectedRows={selectedRows}
          event={handleSelect}
          selectAllEvent={handleSelectAll}
          selectAllStatus={selectAllItems}
          isLoading={isLoading}
        />
      </div>
    </SideBarContainer>
  );
}
